import { render, staticRenderFns } from "./UserNoticeConfig.vue?vue&type=template&id=578610a0&"
import script from "./UserNoticeConfig.vue?vue&type=script&lang=js&"
export * from "./UserNoticeConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports